import t from "prop-types";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import { trackEvent } from "@amplio-common/analytics";
import { Trans } from "@lingui/macro";

import { css } from "@emotion/react";
import { getSupportEmail } from "@amplio-common/funcs/commonFunctionalities";



const rootStyle = ({ colors }) => css`
  display: flex;
  justify-content: center;
  padding: 20px 30px 20px;

  > div > div {
    /* margin-bottom: 10px; */
  }

  svg {
    color: ${colors.primary.main};
    width: 0.7em;
    height: 0.7em;
    margin-right: 2px;
    margin-bottom: -4px;
  }

  a {
    color: ${colors.text.main};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;


const SupportDetails = props => {
  const { showEmail, className, pageName } = props;
  const onClickFunc = (pName) => {
    trackEvent("support button", { "button type": "footing", page: pName });
  };

  const supportEmail = getSupportEmail();

  return (
  // <FormattedMessage id="support_dialog.title" defaultMessage="How Can We Help ?">{() => (
    <div css={rootStyle} className={className}>
      <div>
        {showEmail && (<div><a href={`mailto:${supportEmail}`} target="_blank" rel="noopener noreferrer"><EmailIcon />{supportEmail}</a></div>)}
        <div
          onClick={() => { onClickFunc(pageName); }}
        >
          <a href="tel:+972 3 568-8855" target="_blank" rel="noopener noreferrer">
            <Trans>IL support</Trans> <>03-5688855 </>
            <PhoneIcon />
          </a>
        </div>
      </div>
    </div>
  );
};

SupportDetails.propTypes = {
  className: t.string,
  pageName: t.string,
  showEmail: t.bool,
};

export default SupportDetails;
